import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';
import { AlertaConfirmDialog } from '../alerta-confirm';
import { AlertaSimplesDialog } from '../alerta-simples';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { TamasAlunoService } from '../tamas-aluno.service';

@Component({
  selector: 'app-instexcluir',
  templateUrl: './instexcluir.component.html',
  styleUrls: ['./instexcluir.component.css']
})
export class InstExcluirComponent implements OnInit {
  hideCL: boolean = false;
  constructor(private route: ActivatedRoute, private _location: Location, public router: Router,  public dialog: MatDialog, public tmaService: TamasAlunoService) { }

  ngOnInit() {
    this.tmaService.eventoFS(true);
    this.hideCL = true;
  }

  ngOnDestroy(){
    console.log("destroy");
    this.tmaService.eventoFS(false);
  }

  goHome() :void{
    this.router.navigate(["/"]);
  }

  voltar(): void {
    //this._location.back();
    this.router.navigate(['/abertura']);

  }
}
